module.exports = __webpack_public_path__ + "media/images/iphone_app_mock-64054437a95fbf8b313d962ab607821a.png";